const Style = `
<style>
            :host {
              display: flex;
              flex-direction: column;
              gap: 4px;
              width: calc(100vw - 24px);
            }


            .four-step-block-image {
                border-radius: 11px 11px 0px 0px;
                width: 100%;
                height: 300px;
                background-repeat: no-repeat;
                background-size: cover;
            }

            .four-step-block-content {
            padding: 20px 20px 20px 0;

            }

            .learn-more-container {
                display: flex;
                gap: 6px;
                text-transform: uppercase;
                align-items: center;
                padding: 4px 0px;
            }
            .four-step-block-text-container {
                display: flex;
                flex-direction: column;
                gap: 4px;
                padding-top: 20px;
                padding-left: 20px;
                padding-right: 20px;
            }
             a {
                color: inherit;
                text-decoration: none;
                cursor: pointer;
                display: inline-block;
            }

            </style>
`;

export default Style;
